import React from 'react';
import { Typography } from 'seagull';
import styles from "../ServicesSection.module.scss";
import CreditSwitch from "./CreditSwitch";
import { CreditDeleteButton } from "./CreditDeleteButton";
export default function CreditBillingItem(props) {
  const {
    name,
    costDisplay,
    id,
    isPaused,
    index,
    agreement,
    disabled,
    tooltipTitle,
    onRefresh
  } = props;
  return /*#__PURE__*/React.createElement("li", {
    "data-testid": "service-".concat(index),
    className: styles.serviceBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.serviceDescription
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "name"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: styles.cost
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "cost",
    variant: "paragraph2",
    skin: "secondary"
  }, costDisplay))), /*#__PURE__*/React.createElement("div", {
    className: styles.lineItemAction
  }, /*#__PURE__*/React.createElement(CreditSwitch, {
    "data-testid": "billing-control-credit-".concat(index, "-switch"),
    chargeId: id,
    agreementId: agreement.id,
    disabled: disabled,
    tooltipTitle: tooltipTitle,
    isPaused: isPaused,
    onRefresh: onRefresh
  }), /*#__PURE__*/React.createElement(CreditDeleteButton, {
    chargeId: id,
    agreementId: agreement.id,
    disabled: disabled,
    tooltipTitle: tooltipTitle,
    onRefresh: onRefresh,
    "data-testid": "billing-control-credit-".concat(index, "-delete")
  })));
}